import { AnalyticsPage } from "../../features/analytics";

/** Global ADMIN-only product analytics page (route gated in App.tsx). */
export function AdminAnalyticsPage() {
  return <AnalyticsPage />;
}
